import React from "react";
import { Text, View, StyleSheet, Font } from "@react-pdf/renderer";

const borderColor = "#90e5fc";
const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    borderBottomColor: "#bff0fd",
    backgroundColor: "#bff0fd",
    borderBottomWidth: 1,
    minHeight: 30,
    flexGrow: 1,
    fontSize: "10px",
    alignItems: "center",
    textAlign: "center",
  },
  width5: {
    width: "5%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
  },
  width10: {
    width: "10%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "center",
  },
  width15: {
    width: "15%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "center",
  },
  width20: {
    width: "20%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
  },
  width25: {
    width: "20%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
  },
  width40: {
    width: "35%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "center",
  },
});

export class ProductPurchaseHeaderTable extends React.Component {
  render() {
    return (
      <View style={styles.container} fixed>
        <Text style={styles.width15}>{`Date`}</Text>
        <Text style={styles.width10}>{`Transaction#`}</Text>
        <Text style={styles.width40}>{`ItemDesc`}</Text>
        <Text style={styles.width10}>{`Qty`}</Text>
        <Text style={styles.width10}>{`Unit Price`}</Text>
        <Text style={styles.width10}>{`Total Price`}</Text>
        <Text style={styles.width10}>{`StaffName`}</Text>
      </View>
    );
  }
}
